export const postMessage = (message, target, targetOrigin = '*') => {
    target.postMessage(JSON.stringify(message), { targetOrigin });
};
